// noinspection JSUnresolvedVariable

const {
    parseClone,
    makeImageClone,
    findMinimalOrMaximalPrice,
    findFlatsExactLocale,
    buildNeededData,
    imageAddFields,
    minQuantityFieldAdd,
    handlePriceCommasFormat,
    handleAmdPrice,
    specialPriceTimeToggle,
    formatPrice
} = require("./helpers")

const settingConstants = require("./constants")
const {Get_Exact_Core_Config} = require("./SettingsController")
const {Get_Needed_Attribute} = require("./AttributeController")
const {Get_Form_By_Id} = require("./FormControllers")
const {featuredOrNewAggregate} = require("./aggregations")
const {filterBy} = require("../scripts/filterBy")
const {colorType} = require("../services/color");
// const defaultPicture = require("../images/defaultpic.webp").default;

const productCurrencyToggle = (el, selectedRate, locale) => {
    const {exchange_rate: {rate = 1} = {}} = selectedRate || {}
    const handlePriceName = (priceKey) => {
        const findItem = el?.flats?.find(ii => ii.locale === locale)?.[priceKey];
        if (parseFloat(findItem) === 0 || !!Number(findItem)) {
            return findItem * rate
        }
        return null
    }

    return {
        ...el,
        flats: [
            {
                ...el.flats?.find(ii => ii.locale === locale),
                selectedRate,
                price: handlePriceName("price"),
                min_price: handlePriceName("min_price"),
                max_price: handlePriceName("max_price"),
                special_price: handlePriceName("special_price")
            }
        ]
    }
}

const addMinQuantityController = async (models, productArray) => {
    const minQuantityAttribute = await Get_Needed_Attribute(models, "min_qty", "min_qty")
    const minQuantityAttrValue = await models.product_attribute_values.find({attribute_id: minQuantityAttribute?.min_qty[0]?.id})
    return minQuantityFieldAdd(productArray, minQuantityAttrValue)
}

const allowOutOfStock = async (models) => await Get_Exact_Core_Config(models, settingConstants.Out_Of_Stock)
const outOfStockProductMatch = [
    {$and: [
            { "type": "configurable" },
            { $expr: { $gt: [{
                        $size: {
                            $filter: {
                                input: "$variants",
                                as: "variant",
                                cond: { $gt: ["$$variant.qty", [0]] }
                            }
                        }}, 0]}}
        ]},
    { "type": "downloadable" },
    {
        type: "bundle",
        $expr: {
            $not: {
                $allElementsTrue: {
                    $map: {
                        input: { $ifNull: ["$bundle_options", []] },
                        as: "option",
                        in: {
                            $allElementsTrue: {
                                $map: {
                                    input: { $ifNull: ["$$option.bundle_option_products", []] },
                                    as: "product",
                                    in: { $eq: ["$$product.product_qty", 0] }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    { "qty": { $gt: 0 } }
]

const getNewFeatured = async (models, locale, selectedRate, outStockAllow) => {
    const baseMatch = {
        "flats.locale": locale,
        "flats.status": 1,
        "flats.visible_individually": 1
    };
    if (!Number(outStockAllow)) {
        baseMatch["$or"] = outOfStockProductMatch;
    }
    return await models.products_v2.aggregate([
        {$match: baseMatch},
        {$sort: {"flats.0.product_number": 1}},
        {
            $facet: {
                newProducts: [{$match: {"flats.new": 1}}, {$limit: 12}],
                featuredProducts: [{$match: {"flats.featured": 1}}, {$limit: 12}],
                thirdSectionProducts: [{$match: {"flats.third_section": 1}}, {$limit: 12}],
            }
        },
        {
            $project: {
                combinedProducts: {$concatArrays: ["$newProducts", "$featuredProducts", "$thirdSectionProducts"]}
            }
        },
        {$unwind: "$combinedProducts"},
        {$replaceRoot: {newRoot: "$combinedProducts"}},
        {
            $addFields: {
                flats: {
                    $filter: {
                        input: "$flats",
                        as: "flat",
                        cond: {$eq: ["$$flat.locale", locale]}
                    }
                },
                selectedRate: +selectedRate?.exchange_rate?.rate || 1
            }
        },
        {
            $addFields: {
                flats: {
                    $map: {
                        input: "$flats",
                        as: "flat",
                        in: {
                            $mergeObjects: [
                                "$$flat",
                                {
                                    price: {$multiply: ["$$flat.price", "$selectedRate"]},
                                    min_price: {$multiply: ["$$flat.min_price", "$selectedRate"]},
                                    max_price: {$multiply: ["$$flat.max_price", "$selectedRate"]},
                                    special_price: {$multiply: ["$$flat.special_price", "$selectedRate"]}
                                }
                            ]
                        }
                    }
                }
            }
        },
    ])
}
const getInfiniteScrollValue = async (models) => await Get_Exact_Core_Config(models, settingConstants.Infinite_Scroll)

const handleConfigPrice = (element, selectedRate, selectedLocale) => {
    const minimalPrice = Math.min(...new Set(element.variants.map(el => {
        const variantProduct = productCurrencyToggle(el, selectedRate, selectedLocale);
        const { flats: [ { min_price, price } ] } = variantProduct || {};
        return min_price || price
    })));
    return {
        ...element,
        flats: [{
            ...element.flats[0],
            min_price: Number(minimalPrice),
            price: Number(minimalPrice),
        }],
    }
}

const bundleProductHandle = async ({product, models, selectedRate, locale, outStockAllow}) => {
    if (product && product.type === "bundle") {
        const flatIds = [...new Set(product?.bundle_options?.map(option => {
            return option?.bundle_option_products?.map(option_product => {
                return option_product?.product_id
            })
        }).flat())]
        const productsFinderQueryHandle = {
            "id": {$in: flatIds},
            "flats.status": {$in: ["1", 1]},
            ...(() => {
                if (String(outStockAllow) !== "0") return {}
                return {"qty": {$gt: 0}}
            })(),
        }
        const bundleProdArr = await models.products_v2.find(productsFinderQueryHandle)
        if (bundleProdArr.length === 0) return {}
        const updateWithCurrency = parseClone(bundleProdArr)?.map(el => productCurrencyToggle(el, selectedRate, locale))
        const findBundleProducts = findFlatsExactLocale(updateWithCurrency, locale);
        const sortedBundleOptions = product?.bundle_options?.sort((a, b) => a?.sort_order - b?.sort_order)
        return {
            bundle_options: sortedBundleOptions?.map(({ bundle_option_products, ...option }) => {
                const sortedBundleOptionProducts = bundle_option_products?.sort((a, b) => a?.sort_order - b?.sort_order)
                return {
                    ...option,
                    option_product_info: sortedBundleOptionProducts?.map(option_product => {
                        const findProduct = parseClone(findBundleProducts)?.find(bundleProd => {
                            return bundleProd?.id === option_product?.product_id
                        })
                        if (findProduct) {
                            const {
                                flats: [{
                                    name: productName = "",
                                    min_price: productMinPrice,
                                    price: productPrice = 0
                                } = {}] = [],
                                qty: [productQty],
                            } = findProduct || {};
                            const finalProductQty = String(outStockAllow) !== "0" ? 5000 : productQty
                            const {symbol: currSymbol, code: currCode} = selectedRate || {}
                            const priceFormatted = formatPrice(productMinPrice, selectedRate, locale)
                            const pricePositionHandle = () => {
                                if (currCode !== "AMD") return `${currSymbol}${priceFormatted}`
                                return `${priceFormatted}${currSymbol}`
                            }
                            return {
                                id: option_product?.id,
                                is_default: option_product?.is_default,
                                name: `${productName} + ${pricePositionHandle()}`,
                                productQty: finalProductQty,
                                optionDefaultQty: +option_product?.qty > +finalProductQty ? finalProductQty : option_product?.qty,
                                bundleOptionId: option_product?.product_bundle_option_id,
                                price: productMinPrice ?? productPrice
                            }
                        }
                        return false
                    })
                        ?.filter(elem => elem)
                        ?.map((defaultItemSetter, index, array) => {
                            const hasDefaultItem = array?.some(optProductSome => Boolean(+optProductSome?.is_default));
                            if (hasDefaultItem) return defaultItemSetter;
                            return {
                                ...defaultItemSetter,
                                is_default: index === 0 ? 1 : defaultItemSetter?.is_default
                            }
                        }),
                }
            })?.filter(elem => elem.option_product_info.length > 0),
        }
    }
    return {}
}

/*** NEW FEATURED/NEW PRODUCTS HOME PAGE ***/
const Get_New_And_Featured_Products = async (opts, models) => {
    const {locale, selectedRate, outStockAllow, backOrderValue, isMobile} = opts;

    const filterUniqueObjects = (products, type) => {
        const result = []
        const ids = new Set(products.filter(el => el.flats[0][type] === 1).map(el => el.id))

        for (let elem of ids) {
            result.push(products.find(el => el.id === elem))
        }

        return result
    }

    try {
        const fulfilledNewFeaturedProducts = await getNewFeatured(models, locale, selectedRate, outStockAllow)
        const allProducts = fulfilledNewFeaturedProducts.map(el => !!el.variants.length ? handleConfigPrice(el, selectedRate, locale) : el)

        const newProducts = await addMinQuantityController(models, filterUniqueObjects(allProducts, "new"))
        const featuredProducts = await addMinQuantityController(models, filterUniqueObjects(allProducts, "featured"))
        const thirdSectionProducts = await addMinQuantityController(models, filterUniqueObjects(allProducts, "third_section"))

        const allBlockTitles = await models.attributes.find({code: {$in: ["new", "featured", "third_section"]}});
        const {translations: blockIntl_new} = allBlockTitles[0]
        const {translations: blockIntl_featured} = allBlockTitles[1]
        const {translations: blockIntl_third} = allBlockTitles[2] || {}
        const {name: translatedBlockTitleNew = ""} = blockIntl_new.find(el => el.locale === locale) || {}
        const {name: translatedBlockTitleFeatured = ""} = blockIntl_featured.find(el => el.locale === locale) || {}
        const {name: translatedBlockTitleThird = ""} = blockIntl_third?.find(el => el.locale === locale) || {}
        const productFinalResultHandle = async (productList, blockTitle) => {
            return parseClone(await Promise.all(productList.map(async elem => {
                const options = await models.product_options.find({product_id: elem.id, required: {$in: [1, "1"]}});
                const priceHandler = async () => {
                    if (elem.type === "bundle") {
                        const bundle_options = await bundleProductHandle({
                            product: elem,
                            models,
                            locale,
                            selectedRate,
                            outStockAllow,
                        })
                        const optionQuantity = bundle_options?.bundle_options?.map(({option_product_info}) => {
                            return option_product_info?.find(findItem => !!findItem?.is_default) || {}
                        })
                        const totalPrice = optionQuantity?.reduce((total, { optionDefaultQty, price }) => {
                            return total + optionDefaultQty * price;
                        }, 0);
                        return {
                            price: formatPrice(totalPrice, selectedRate, locale),
                            special_price: null,
                            min_price: formatPrice(totalPrice, selectedRate, locale),
                        }
                    }
                    const spPriceNumber = specialPriceTimeToggle(elem, selectedRate, locale)
                    return {
                        price: formatPrice(elem.flats[0].price, selectedRate, locale),
                        special_price: spPriceNumber ? formatPrice(spPriceNumber, selectedRate, locale) : null,
                        min_price: formatPrice(elem.flats[0].min_price, selectedRate, locale)
                    }
                }
                const minQty = elem.flats[0].min_qty ? elem.flats[0].min_qty : 0
                const inStockHandle = () => {
                    switch (elem.type) {
                        case "downloadable":
                        case "bundle":
                        case "configurable":
                            return false;
                        default:
                            if (options.length > 0 || minQty > 1) return false
                            return elem.qty[0] > 0 || !!parseFloat(backOrderValue);
                    }
                }
                return {
                    ...elem,
                    isProductInStock: inStockHandle(),
                    flats: [{
                        ...elem.flats[0],
                        name: elem.flats[0].name ?? "",
                        min_qty: minQty,
                        ...(await priceHandler()),
                        short_description: elem.flats[0].short_description?.replace(/<\/?[^>]+>/gi, "")
                    }],
                    block_title: blockTitle,
                    images: elem.images.length > 0
                        ? elem.images.map(el => `/storage/${isMobile ? "big_medium" : "small_large"}/${el}`)
                        : ["/_next/static/media/defaultpic.119a8e64.webp"]
                }
            })));
        }
        return {
            newProducts: await productFinalResultHandle(newProducts, translatedBlockTitleNew),
            featuredProducts: await productFinalResultHandle(featuredProducts, translatedBlockTitleFeatured),
            thirdSectionProducts: await productFinalResultHandle(thirdSectionProducts, translatedBlockTitleThird)
        };
    } catch (err) {
        throw err;
    }
}

const getSearchProducts = async (models, locale, query, selectedRate, defaultLngCode, domain, searchDetails, HomeIntl, homeImg, backOrderValue, isSuggestion) => {
    const removeAllSpaces = string => {
        // return string?.toLowerCase().replace(/\s+/g, '');
        return string?.toLowerCase();
    }
    const removeHtmlTags = string => {
        return string?.toLowerCase().replace(/<\/?[^>]+>/g, '');
    }
    const escapeRegExp = string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const buildProductSearchMatch = (searchQuery, allowResponse) => {
        const productSearchRegex = new RegExp(escapeRegExp(removeAllSpaces(searchQuery)), "i");
        const baseMatch = {
            $and: [
                {"flats.status": 1},
                {
                    $or: [
                        {sku: productSearchRegex},
                        {"flats.name": productSearchRegex},
                        {"flats.description": productSearchRegex},
                        {"flats.short_description": productSearchRegex}
                    ]
                }
            ]
        }

        if (!Number(allowResponse)) {
            baseMatch.$and.push({$or: outOfStockProductMatch})
        }

        return baseMatch
    }
    const searchForProducts = async () => {
        if (!Number(searchDetails?.product_search) || !query) return []
        const allowResponse = await allowOutOfStock(models);
        let productsQuery = models.products_v2.find(buildProductSearchMatch(query, allowResponse));

        if (isSuggestion) {
            productsQuery = productsQuery.limit(50);
        }

        const updatedProducts = await productsQuery.lean();
        const updateQuantityRes = await addMinQuantityController(models, updatedProducts);
        const fillAllFlats = updateQuantityRes.map((eachPr) => {
            const eachPrObj = typeof eachPr.toObject === 'function' ? eachPr.toObject() : eachPr;
            const findFlatIntl = eachPrObj?.flats?.find(productFl => productFl?.locale === locale);
            const findFlatDefault = eachPrObj?.flats?.find(productFl => productFl?.locale === defaultLngCode) || {}
            if (!findFlatIntl || Object.keys(findFlatIntl).length === 0) {
                return {
                    ...eachPrObj,
                    flats: [findFlatDefault]
                }
            }
            const flatPropertyToggle = (key) => findFlatIntl?.[key] ?? findFlatDefault?.[key]
            const emptyFlatFill = {
                name: flatPropertyToggle("name"),
                min_qty: flatPropertyToggle("min_qty"),
                description: flatPropertyToggle("description"),
                status: flatPropertyToggle("status"),
                price: flatPropertyToggle("price"),
                min_price: flatPropertyToggle("min_price"),
                special_price: flatPropertyToggle("special_price"),
                short_description: flatPropertyToggle("short_description"),
            }
            return {
                ...eachPrObj,
                flats: [{...findFlatIntl, ...emptyFlatFill}]
            }
        })
        return await Promise.all(fillAllFlats.map(async el => {
            const custom_options = await models.product_options.find({product_id: el.id, required: {$in: [1, "1"]}});
            const minQty = el?.flats?.[0]?.min_qty ? el?.flats?.[0]?.min_qty : 0
            const inStockHandle = () => {
                switch (el.type) {
                    case "downloadable":
                    case "bundle":
                    case "configurable":
                        return false;
                    default:
                        if (custom_options?.length > 0 || minQty > 1) return false
                        return el?.qty?.[0] > 0 || !!parseFloat(backOrderValue);
                }
            }
            const searchedLocale = el?.flats?.[0]?.locale === locale ? locale : defaultLngCode
            const spPriceNumber = specialPriceTimeToggle(el, selectedRate, locale)
            const mainBody = {
                ...productCurrencyToggle({
                    ...el,
                    flats: [{
                        ...el.flats[0],
                        price: handleAmdPrice(selectedRate, el?.flats?.[0]?.price),
                        special_price: spPriceNumber ? handleAmdPrice(selectedRate, spPriceNumber) : null,
                        min_price: handleAmdPrice(selectedRate, el?.flats?.[0]?.min_price),
                    }],
                }, selectedRate, searchedLocale),
                images: el.images.length > 0
                    ? el.images.map(elem => `/storage/${elem}`)
                    : ["/_next/static/media/defaultpic.119a8e64.webp"]
            }
            if (!!el.variants.length) {
                return {
                    ...handleConfigPrice(mainBody, selectedRate, searchedLocale),
                    flats: [{
                        ...el.flats[0],
                        price: formatPrice(handleConfigPrice(mainBody, selectedRate, searchedLocale)?.flats?.[0]?.price, selectedRate, locale),
                        min_price: formatPrice(handleConfigPrice(mainBody, selectedRate, searchedLocale)?.flats?.[0]?.min_price, selectedRate, locale),
                        special_price: el?.flats?.[0]?.special_price
                            ? formatPrice(
                                specialPriceTimeToggle(
                                    handleConfigPrice(mainBody, selectedRate, searchedLocale),
                                    selectedRate,
                                    locale
                                ), selectedRate, locale
                            ) : null
                    }]
                }
            }
            if (el.type === "bundle") {
                const bundle_options = await bundleProductHandle({
                    product: el,
                    models,
                    locale: searchedLocale,
                    selectedRate,
                    outStockAllow: allowResponse
                })
                const optionQuantity = bundle_options?.bundle_options?.map(({option_product_info}) => {
                    return option_product_info?.find(findItem => !!findItem.is_default) || {}
                })
                const totalPrice = optionQuantity?.reduce((total, { optionDefaultQty, price }) => {
                    return total + optionDefaultQty * price;
                }, 0);
                return {
                    ...mainBody,
                    flats: [{
                        ...el.flats[0],
                        price: formatPrice(totalPrice, selectedRate, locale),
                        min_price: formatPrice(totalPrice, selectedRate, locale),
                        special_price: null
                    }]
                }
            }
            return {
                ...mainBody,
                isProductInStock: inStockHandle(),
                flats: [{
                    ...el.flats[0],
                    min_qty: minQty,
                    price: formatPrice(mainBody.flats[0].price, selectedRate, locale),
                    min_price: formatPrice(mainBody.flats[0].min_price, selectedRate, locale),
                    special_price: spPriceNumber ? formatPrice(spPriceNumber, selectedRate, locale) : null
                }]
            }
        }))
    }
    const searchForPages = async () => {
        if (!Number(searchDetails?.page_search)) return []
        const pages = await models.pages.find({}).lean();
        const filteredPages = pages.filter((elem) => {
            if (query) {
                const pageQueryLower = removeAllSpaces(query);
                const allIntlNames = [...new Set(elem?.translations?.map(tr => removeAllSpaces(tr?.page_title)))]
                const allIntlContent = [...new Set(elem?.translations?.map(tr => removeAllSpaces(removeHtmlTags(tr?.html_content))))]
                const pageNameLower = removeAllSpaces(elem?.page_title);
                const pageContentLower = removeAllSpaces(removeHtmlTags(elem?.html_content))
                allIntlNames.push(pageNameLower)
                allIntlContent.push(pageContentLower)
                const setPageNames = [...new Set(allIntlNames)];
                const setPageContents = [...new Set(allIntlContent)];
                return setPageNames.some(eachInfo => eachInfo.includes(pageQueryLower))
                    || setPageContents.some(eachInfo => eachInfo.includes(pageQueryLower))
            }
            return false;
        }) || []
        const searchedComponentsInfo = (componentItem) => ({
            Heading: componentItem?.headingText,
            Editor: removeHtmlTags(componentItem?.textEditorValue),
            Accordion: componentItem?.accordionFaq?.map((faqItem) => `${removeHtmlTags(faqItem?.title)} ${removeHtmlTags(faqItem?.description)}`)?.join(" "),
            DropList: componentItem?.dropList?.map((dropItem) => `${removeHtmlTags(dropItem?.title)} ${removeHtmlTags(dropItem?.content)}`)?.join(" "),
            Button: componentItem?.buttonValue,
            Tab: componentItem?.tabSettings?.tabItems?.map((tabItem) => `${removeHtmlTags(tabItem?.title)} ${removeHtmlTags(tabItem?.content)}`)?.join(" "),
            TimelineChart: componentItem?.timelineSettings?.points?.map((timeItem) => `${removeHtmlTags(timeItem?.heading)} ${removeHtmlTags(timeItem?.content)}`)?.join(" "),
            FormBuilder: `${componentItem?.form?.name} ${componentItem?.form_builder_json?.map(({ label } = {}) => {
                return label ? removeHtmlTags(label) : ''
            })?.join(" ")}`,
            ImageBox: componentItem?.carousel?.cards?.map((carouselItem) => `${removeHtmlTags(carouselItem?.title)} ${removeHtmlTags(carouselItem?.buttonContent)}`)?.join(" "),
            Testimonials: componentItem?.carousel?.cards
                ?.map(({ title = "", buttonContent = "", description = "" } = {}) => `${removeHtmlTags(title)} ${removeHtmlTags(buttonContent)} ${removeHtmlTags(description)}`)
                ?.join(" "),
            ContentTable: componentItem?.contentTableSettings?.tableItems?.map((faqItem) => removeHtmlTags(faqItem?.rowName))?.join(" "),
            Slider: componentItem?.slider?.slides?.map((slidesItem) =>
                `${removeHtmlTags(slidesItem?.content?.title)} ${removeHtmlTags(slidesItem?.content?.description)} ${removeHtmlTags(slidesItem?.content?.buttonText)}`
            )?.join(" ")
        })
        const builderKeysForFilter = Object.keys(searchedComponentsInfo({}))
        const builderContent = await models.page_builder.find({}).lean();
        for (const elem of parseClone(builderContent)) {
            const filteredComponents = elem?.components?.filter(filItem => {
                return builderKeysForFilter.some(keyEachItem => keyEachItem === Object.values(filItem)?.[0]?.content)
            });
            const pageQueryLower = removeAllSpaces(query);
            const searchContent = await Promise.all(filteredComponents.map(async filteredObj => {
                const componentItem = Object.values(filteredObj)?.[0]
                if (componentItem?.content === "FormBuilder") {
                    const formComponent = await Get_Form_By_Id({form_id: componentItem?.form?.id, locale}, models)
                    return removeAllSpaces(searchedComponentsInfo(
                        {form: componentItem?.form, form_builder_json: formComponent?.data?.form_builder_json}
                    )[componentItem?.content])
                }
                return removeAllSpaces(searchedComponentsInfo(componentItem)[componentItem?.content])
            }))
            const searchExist = searchContent.some(ii => ii?.includes(pageQueryLower));
            if (searchExist) {
                if (elem?.page_id === 2) {
                    const findItem = filteredPages?.find(pageEach => pageEach?.id === 2);
                    if (!findItem) {
                        filteredPages?.push({
                            translations: [{ locale, page_title: HomeIntl }],
                            id: 2,
                            image: homeImg ?? "/_next/static/media/defaultpic.119a8e64.webp",
                            url_key: "/"
                        })
                    }
                } else {
                    const findItem = filteredPages?.find(pageEach => pageEach?.id === elem?.page_id);
                    if (!findItem) {
                        const findPage = pages?.find(pageElem => pageElem?.id === elem?.page_id) || null
                        if (findPage) filteredPages?.push(findPage)
                    }
                }
            }
        }
        return filteredPages?.map(eachPage => {
            const intlTitle = eachPage?.translations?.find(ii => ii?.locale === locale)
            return {
                id: eachPage?.id,
                images: eachPage?.image
                    ? [`/storage/${domain}/${eachPage?.image}`]
                    : ["/_next/static/media/defaultpic.119a8e64.webp"],
                flats: [{ url_key: eachPage?.url_key === "/" ? "/" : `page/${eachPage?.url_key}`, name: intlTitle?.page_title }],
                notProduct: true
            }
        })
    }

    const searchForPosts = async () => {
        if (!Number(searchDetails?.post_search)) return [];
        const posts = await models.posts.find({}).lean();
        const filteredPosts = posts.filter((elem) => {
            if (query) {
                const postQueryLower = removeAllSpaces(query);
                const allIntlNames = [...new Set(elem?.translations?.map(tr => removeAllSpaces(tr?.name)))]
                const allIntlDesc = [...new Set(elem?.translations?.map(tr => removeAllSpaces(tr?.description)))]
                const postNameLower = removeAllSpaces(elem?.name);
                const postDescLower = removeAllSpaces(removeHtmlTags(elem?.description));
                allIntlNames.push(postNameLower)
                allIntlDesc.push(postDescLower)
                const setPostNames = [...new Set(allIntlNames)];
                const setPostDesc = [...new Set(allIntlDesc)];
                return setPostNames.some(eachInfo => eachInfo.includes(postQueryLower))
                    || setPostDesc.some(eachInfo => eachInfo.includes(postQueryLower))
            }
            return false;
        })
        return await Promise.all(filteredPosts?.map(async eachPost => {
            const intlTitle = eachPost?.translations?.find(ii => ii?.locale === locale);
            const catPost = await models.post_categories_posts.find({blog_post_id: eachPost?.id});
            const postCategory = await models.post_categories.find({id: catPost?.[0]?.blog_category_id});
            return {
                id: eachPost?.id,
                images: eachPost?.image
                    ? [`/storage/${domain}/${eachPost?.image}`]
                    : ["/_next/static/media/defaultpic.119a8e64.webp"],
                flats: [{ url_key: `posts/${postCategory?.[0]?.slug}/${eachPost?.slug}`, name: intlTitle?.name }],
                notProduct: true
            }
        }))
    }
    return [...await searchForProducts(), ...await searchForPages(), ...await searchForPosts()]
}

/*** NEW SEARCH LOGIC ***/
const Get_Searched_Products = async (models, locale, query, selectedRate, defaultLngCode, domain, searchDetails, HomeIntl, homeImg, backOrderValue, isSuggestion) => {
    try {
        return await getSearchProducts(models, locale, query, selectedRate, defaultLngCode, domain, searchDetails, HomeIntl, homeImg, backOrderValue, isSuggestion)
    } catch (err) {
        throw err;
    }
}


/*** NEW PRODUCT INNER PAGE ***/
const Get_Product_For_Product_Inner_Page = async (productSlug, options, models) => {
    const {locale, selectedRate} = options;
    try {
        const allowResponse = await allowOutOfStock(models);
        const sku = await Get_Needed_Attribute(models, "sku", "sku_option")
        const shDesc = await Get_Needed_Attribute(models, "short_description", "short_description_option")
        const desc = await Get_Needed_Attribute(models, "description", "description_option")
        const findLocale = (attr) => attr?.translations?.find(({locale: trLocale}) => trLocale === locale)
        const productSkuName = findLocale(sku?.sku_option?.[0]) || "SKU";
        const productDescName = findLocale(desc?.description_option[0]) || "";
        const productShortDescName = findLocale(shDesc?.short_description_option[0]) || "";
        const data = await models.products_v2.aggregate([
            {
                $match: {
                    flats: {
                        $elemMatch: {
                            locale: locale,
                            url_key: productSlug,
                            status: 1
                        }
                    }
                },
            },
            {
                $lookup: {
                    from: "products_v2",
                    localField: "parent_id",
                    foreignField: "id",
                    as: "parent",
                },
            },
            {
                $addFields: {
                    productData: {
                        $cond: [
                            { $and: [
                                    { $ne: ["$parent_id", null] },
                                    { $ne: ["$parent_id", ""] },
                                    { $gt: [{ $size: "$parent" }, 0] }
                                ]},
                            { $arrayElemAt: ["$parent", 0] },
                            "$$ROOT"
                        ],
                    },
                },
            },
            {
                $addFields: {
                    "productData.variants": {
                        $cond: [
                            {
                                $and: [
                                    { $ne: ["$parent_id", null] },
                                    { $ne: ["$parent_id", ""] },
                                    { $gt: [{ $size: "$parent" }, 0] }
                                ]
                            },
                            {
                                $map: {
                                    input: "$productData.variants",
                                    as: "variant",
                                    in: {
                                        $mergeObjects: [
                                            "$$variant",
                                            {
                                                is_selected: {
                                                    $eq: ["$$variant.id", "$id"],
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                            "$productData.variants"
                        ],
                    },
                },
            },
            {
                $replaceRoot: { newRoot: "$productData" },
            },
        ]);
        const res = findFlatsExactLocale(data, locale)
        const newRes = parseClone(res);
        const findVariantsWithLocale = newRes[0]?.variants ? findFlatsExactLocale(newRes[0]?.variants, locale) : [];
        const yoast_products = await models.yoast_products.find({locale, product_id: newRes[0]?.id})
        const [{
            yoast_facebook_description: yfd = "",
            yoast_facebook_title: yft = "",
            yoast_twitter_description: ytd = "",
            yoast_twitter_title: ytt = "",
            yoast_focus_keyword: yfk = ""
        } = {}] = parseClone(yoast_products);
        const updatedYoasts = [{
            yoast_facebook_description: !!yfd ? yfd : newRes[0]?.flats[0]?.meta_description,
            yoast_facebook_title: !!yft ? yft : newRes[0]?.flats[0]?.meta_title,
            yoast_twitter_description: !!ytd ? ytd : newRes[0]?.flats[0]?.meta_description,
            yoast_twitter_title: !!ytt ? ytt : newRes[0]?.flats[0]?.meta_title,
            yoast_focus_keyword: !!yfk ? yfk : newRes[0]?.flats[0]?.meta_keywords
        }]
        const updatedResWithCurr = [{
            ...newRes[0],
            ...(await bundleProductHandle({
                    locale,
                    product: newRes[0],
                    selectedRate,
                    models,
                    outStockAllow: allowResponse
                })
            ),
            variants: findVariantsWithLocale.map(el => productCurrencyToggle(el, selectedRate, locale)),
            yoast_products: updatedYoasts
        }]
        let variantsIndex = newRes[0]?.variants?.map((el) => el?.id) || [];
        // const variantsAttr = await models.product_attribute_values.find({product_id: {$in: variantsIndex}});
        // const productAttributeValues = await models.product_attribute_values.find({product_id: data[0]?.id});
        const combinedVersionAttrValues = await models.product_attribute_values.find({product_id: {$in: [...variantsIndex, data[0]?.id]}});
        const parsedCombinedVersionAttrValues = parseClone(combinedVersionAttrValues)
        const productAttributeValues = parsedCombinedVersionAttrValues.filter(elem => elem?.product_id === data[0]?.id)
        const variantsAttr = parsedCombinedVersionAttrValues.filter(elem => elem?.product_id !== data[0]?.id)
        const parsedVariantsAttr = parseClone(variantsAttr)
        const productSuperAttributes = await models.product_super_attributes.find({product_id: data[0]?.id})
        const parsedSuperAttributes = parseClone(productSuperAttributes)
        const superAttrIds = parsedSuperAttributes.map(item => item.attribute_id)
        const attributes = await models.attributes.find({id: {$in: superAttrIds}});
        const attributeOptionsAttr = await models.attribute_options.find({attribute_id: {$in: superAttrIds}});
        const parsedAttributes = parseClone(attributes)
        const parsedAttributesOptions = parseClone(attributeOptionsAttr)
        const parsedProductAttributeValues = parseClone(productAttributeValues)
        const attributeIds = parsedProductAttributeValues.map(item => item.attribute_id);
        const attributesDetail = await models.attributes.find({id: {$in: attributeIds}});
        const parsedAttributesDetail = parseClone(attributesDetail)
        const attributeOptions = await models.attribute_options.find({attribute_id: {$in: attributeIds}});
        const parsedAttributeOptions = parseClone(attributeOptions)
        const handleVariants = (id) => parsedVariantsAttr.filter((variant) => variant.product_id === id);
        const attributesRes = parsedAttributes.map((attribute) => {
            const matchingOptions = parsedAttributesOptions.filter((option) => option.attribute_id === attribute.id);
            const attributeOptions = matchingOptions.map((option) => ({
                ...option,
                attribute: {
                    ...attribute,
                    translations: [attribute?.translations?.find(({locale: itemLoc}) => itemLoc === locale) || {}]
                },
            }));

            return {
                ...attribute,
                attribute_options: attributeOptions.map((elem) => {
                    return {
                        ...elem,
                        swatch_value: colorType(elem.swatch_value),
                        colorsStyle: elem.swatch_value ?? null,
                        translations: [elem?.translations?.find(({locale: itemLoc}) => itemLoc === locale) || {}]
                    }
                }).sort(({sort_order: sortA}, {sort_order: sortB}) => sortA - sortB),
                translations: attribute?.translations?.filter(({locale: itemLoc}) => itemLoc === locale) || []
            };
        });
        const resultAttributes = attributesRes.map((elem) => {
            const matchingOptions = parsedSuperAttributes.filter((option) => {
                return option.attribute_id === elem.id;
            });
            return {
                attributes_values: [elem],
                ...matchingOptions[0]
            }
        })
        const updatedResultAttributes = resultAttributes.map(({attribute_id, product_id, _id, ...attributes}) => {
            const {attributes_values: [{attribute_options}], ...selectedAttributeObj} = attributes;
            const [selectedAttribute] = Object.keys(selectedAttributeObj);
            return {
                ...attributes,
                attribute_options: attribute_options.filter(({id}) => attributes[selectedAttribute].some(el => el === id))
            }
        })
        // const exceptArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 26, 27, 29]
        const codesArray = [
            "sku", "name", "url_key", "tax_category_id", "new", "featured", "visible_individually", "status",
            "short_description", "description", "price", "cost", "special_price", "special_price_from",
            "special_price_to", "meta_title", "meta_keywords", "meta_description", "third_section",
            "min_qty", "guest_checkout", "product_number"
        ]

        const filterDetails = (arr) => {
            const filteredArray = arr.filter(elem => {
                const findItem = parsedAttributesDetail.find(ii => ii.id === elem.attribute_id);
                return codesArray.every(everyIt => everyIt !== findItem?.code)
            })
            return filteredArray.map(item => {
                const attribute = parsedAttributesDetail.filter(attr => attr.id === item.attribute_id).map(el => {
                    return {
                        ...el,
                        ...el.translations.find(elem => elem.locale === locale)
                    }
                });
                const options = parsedAttributeOptions.filter(option => option.attribute_id === item.attribute_id);
                return {
                    ...item,
                    attribute,
                    attribute_options: options
                };
            }).map(el => {
                const attributeOptionsFinder = (value) => {
                    return el.attribute_options.find(elem => String(elem.id) === String(value))?.translations.find(el => el.locale === locale)?.label
                }
                const attributeTypeHandler = {
                    select: attributeOptionsFinder(el.integer_value),
                    //TODO!!! Why we need this? text and textarea does not have any attribute options to find it !!
                    // text: attributeOptionsFinder(el.text_value),
                    // textarea: attributeOptionsFinder(el.text_value),
                    text: el.text_value,
                    textarea: el.text_value,
                    datetime: el.datetime_value,
                    date: el.date_value,
                    price: el.float_value ? `${(+el.float_value).toFixed(2)}$` : el.float_value,
                    boolean: el.boolean_value,
                    multiselect: el.text_value?.split(',').map(value => attributeOptionsFinder(value)).filter(elem => !!elem).join(', '),
                    checkbox: el.text_value?.split(',').map(value => attributeOptionsFinder(value)).filter(elem => !!elem).join(', '),
                    image: el.text_value,
                    file: el.text_value
                }

                return {
                    ...el,
                    attribute_name: el.attribute[0]?.name || el.attribute[0]?.code || null,
                    attribute_value: attributeTypeHandler[el.attribute[0]?.type] || null
                }
            })
            .filter(el => +el.attribute?.[0]?.is_visible_on_front === 1 && !!el.attribute_value)
        }

        if (!res || res.length === 0) {
            return []
        }
        const modifiedRes = await Promise.all(updatedResWithCurr.map(async (elem) => {
            try {
                const minQuantityVal = elem.variants;
                const productOptions = new Promise((resolve, reject) => {
                    models.product_options.find({product_id: elem.id}).lean().exec((err, productOptions) => {
                        if (err) {
                            reject(err);
                            return;
                        }
                        models.product_option_values.find().exec((err, productOptionValues) => {
                            if (err) {
                                reject(err);
                                return;
                            }
                            const options = productOptions.map(option => {
                                const optionIntlTitle = option?.translations?.find(({locale: itemLoc}) => itemLoc === locale)?.title;
                                const children = productOptionValues
                                    .filter(value => value.product_option_id === option.id)
                                    .sort((a, b) => a.sort_order - b.sort_order)
                                    .map(value => {
                                        let label = value.label;
                                        if (value.translations && value.translations.length > 0) {
                                            const translation = value.translations.find(trans => trans.locale === locale);
                                            if (translation) {
                                                label = translation.label;
                                            }
                                        }
                                        return {
                                            id: value.id,
                                            label: label,
                                            admin_name: value.admin_name,
                                            price: value.price,
                                            sort_order: value.sort_order
                                        };
                                    });

                                return {
                                    ...option,
                                    price: option.price ? `${formatPrice( option.price * selectedRate?.exchange_rate?.rate, selectedRate, locale)} ${selectedRate?.symbol}` : null ,
                                    title: optionIntlTitle ? optionIntlTitle :option.title,
                                    children,
                                };
                            });

                            resolve(options);
                        });
                    });
                });
                const variantIdExistToggle = () => {
                    const {qty: [maxVariantQuantity = 0] = []} = elem.variants
                        ?.find(({id: variantId}) => variantId === Number(elem.additional?.default_variant_id)) || {};
                    return maxVariantQuantity;
                }
                const productElementOptions = {
                    sku_option: productSkuName,
                    short_description_option: productShortDescName,
                    description_option: productDescName,
                    details: filterDetails(parsedProductAttributeValues),
                    attributes: updatedResultAttributes,
                    product_options: JSON.parse(JSON.stringify(await productOptions)),
                }

                elem.variants = await Promise.all(minQuantityVal.map(async (el) => {
                    el.product_attribute_values = handleVariants(el?.id);
                    el.details = filterDetails(el?.product_attribute_values);
                    const productOptions1 = new Promise((resolve, reject) => {
                        models.product_options.find({product_id: el.id}).lean().exec((err, productOptions) => {
                            if (err) {
                                reject(err);
                                return;
                            }
                            models.product_option_values.find().exec((err, productOptionValues) => {
                                if (err) {
                                    reject(err);
                                    return;
                                }
                                const options = productOptions.map(option => {
                                    const optionIntlTitle = option?.translations?.find(({locale: itemLoc}) => itemLoc === locale)?.title;
                                    const children = productOptionValues
                                        .filter(value => value.product_option_id === option.id)
                                        .sort((a, b) => a.sort_order - b.sort_order)
                                        .map(value => {
                                            let label = value.label;
                                            if (value.translations && value.translations.length > 0) {
                                                const translation = value.translations.find(trans => trans.locale === locale);
                                                if (translation) {
                                                    label = translation.label;
                                                }
                                            }
                                            return {
                                                id: value.id,
                                                label: label,
                                                admin_name: value.admin_name,
                                                price: value.price,
                                                sort_order: value.sort_order
                                            };
                                        });

                                    return {
                                        ...option,
                                        price: option.price ? `${formatPrice(option.price * selectedRate?.exchange_rate?.rate, selectedRate, locale)} ${selectedRate?.symbol}` : null ,
                                        title: optionIntlTitle ? optionIntlTitle :option.title,
                                        children,
                                    };
                                });

                                resolve(options);
                            });
                        });
                    });
                    return {
                        ...el,
                        maxQty: variantIdExistToggle(),
                        min_qty: el.flats[0].min_qty || 1,
                        ...productElementOptions,
                        product_options: JSON.parse(JSON.stringify(await productOptions1)),
                    };
                }));
                return {
                    ...elem,
                    ...productElementOptions
                };
            } catch (error) {
                console.error(error);
                return elem;
            }
        }));
        if (!modifiedRes || modifiedRes?.length === 0) return {notFound: true}
        const updatedWithCurrProduct = modifiedRes.map(curr => productCurrencyToggle(curr, selectedRate, locale))
        return updatedWithCurrProduct.map((element) => {
            const replaceDesc = (str) => {
                if (!str) return str;
                const tableRegex = /<table[\s\S]*?<\/table>/g;
                const tables = str.match(tableRegex);

                if (!tables) return str;

                tables.forEach(table => {
                    const wrapper = `<div className="table_wrapper" style="overflow: scroll">${table}</div>`;
                    str = str.replace(table, wrapper);
                });
                return str;
            };

            const stripTags = (html) => {
                return html?.replace(/<[^>]*>/g, '');
            }
            const minimalPriceHandle = priceKey => {
                if (element.type === "bundle") {
                    return element.flats[0][priceKey]
                }
                if (!!element.variants.length) {
                    return formatPrice(Math.min(
                            ...new Set(element.variants.map(el => el.flats[0].min_price))
                        ), selectedRate, locale
                    )
                }
                return handleAmdPrice(selectedRate, element.flats[0][priceKey]);
            }

            const translatedDownloadableLinks = (elemKey, downloadable_id_key) => element[elemKey].map((each_link) => {
                const {exchange_rate: {rate = 1} = {}} = selectedRate || {}
                const currTranslation = each_link.translations.find(
                    trIntl => trIntl.locale === locale && each_link.id === trIntl[downloadable_id_key]
                );
                if (currTranslation) {
                    return {
                        ...each_link,
                        title: currTranslation.title,
                        price: handleAmdPrice(selectedRate, each_link.price * rate)
                    }
                }
                return each_link
            })

            return {
                ...element,
                attributes: updatedResultAttributes,
                images: element.images.length > 0
                    ? element.images.map(elem => `/storage/${elem}`)
                    : ["/_next/static/media/defaultpic.119a8e64.webp"],
                flats: [{
                    ...element.flats[0],
                    short_description: replaceDesc(element.flats[0].short_description),
                    description: replaceDesc(element.flats[0].description),
                    min_qty: element.flats[0].min_qty ?? 0,
                    meta_title: !!element.flats[0].meta_title ? element.flats[0].meta_title : element.flats[0].name,
                    meta_description: !!element.flats[0].meta_description ? element.flats[0].meta_description : stripTags(element.flats[0].short_description) ?? null,
                    price: minimalPriceHandle("price"),
                    min_price: minimalPriceHandle("min_price"),
                    special_price: specialPriceTimeToggle(element, selectedRate, locale)
                }],
                yoast_products: element.yoast_products.map((el) => {
                    return {
                        ...el,
                        yoast_facebook_title: el.yoast_facebook_title !== "" ? el.yoast_facebook_title : element.flats[0].meta_title ? element.flats[0].meta_title : element.flats[0].name,
                        yoast_facebook_description: el.yoast_facebook_description !== "" ? el.yoast_facebook_description : element.flats[0].meta_description ? element.flats[0].meta_description : stripTags(element.flats[0].short_description),
                        yoast_twitter_title: el.yoast_twitter_title !== "" ? el.yoast_twitter_title : element.flats[0].meta_title ? element.flats[0].meta_title : element.flats[0].name,
                        yoast_twitter_description: el.yoast_twitter_description !== "" ? el.yoast_twitter_description : element.flats[0].meta_description ? element.flats[0].meta_description : stripTags(element.flats[0].short_description),
                    }
                }),
                variants: element.variants.map(el => {
                    return {
                        ...el,
                        flats: [{
                            ...el.flats[0],
                            price: formatPrice(el.flats[0].price, selectedRate, locale),
                            special_price: specialPriceTimeToggle(el, selectedRate, locale),
                            min_price: formatPrice(el.flats[0].min_price, selectedRate, locale),
                        }],
                        images: !!el.images.length
                            ? el.images.map(elem => `/storage/${elem}`)
                            : element.images.length > 0
                                ? element.images.map(elem => `/storage/${elem}`)
                                : ["/_next/static/media/defaultpic.119a8e64.webp"],
                    }
                }),
                downloadable_links: element.type === "downloadable"
                    ? translatedDownloadableLinks("downloadable_links", "product_downloadable_link_id")
                        .sort((a, b) => (a.sort_order) - (b.sort_order))
                    : null,
                downloadable_samples: element.type === "downloadable"
                    ? translatedDownloadableLinks("downloadable_samples", "product_downloadable_sample_id")
                        .sort((a, b) => (a.sort_order) - (b.sort_order))
                    : null
            }
        })
    } catch (error) {
        throw error;
    }
};
/*** NEW RELATED PRODUCTS ***/
// WITH --> router get !!!!!!!!!!!
const Get_Related_Products = async (options, models) => {
    const {locale, limit, category_id, product_id, currency, backOrderValue} = options;
    let productIds = [];
    try {
        const allowResponse = await allowOutOfStock(models);
        const productRelations = await models.products_relations.find({parent_id: {$in: [product_id]}});
        if (productRelations.length > 0) {
            productIds = productRelations.map((e) => e.child_id).filter(id => id !== product_id);
        } else {
            const productsCategories = await models.products_categories.find({category_id: {$in: category_id}});
            productIds = productsCategories.map((e) => e.product_id).filter(id => id !== product_id);
        }
        const query = {
            "flats.locale": locale,
            "flats.status": 1,
            id: {$in: productIds},
            parent_id: null,
        }
        if (!Number(allowResponse)) {
            query["$or"] = outOfStockProductMatch
        }

        const res = await
            models
                .products_v2
                .find(query)
                .limit(limit)
        const clonedRes = parseClone(res);
        const filteredProductFlats = findFlatsExactLocale(clonedRes, locale)
        // const updateQuantityRes = await addMinQuantityController(models, filteredProductFlats)
        // const modifiedRes = imageAddFields(updateQuantityRes, options)
        return await Promise.all(filteredProductFlats.map(async el => {
                const custom_options = await models.product_options.find({product_id: el.id, required: {$in: [1, "1"]}});
                const minQty = el?.flats?.[0]?.min_qty ? el?.flats?.[0]?.min_qty : 0
                const inStockHandle = () => {
                    switch (el.type) {
                        case "downloadable":
                        case "bundle":
                        case "configurable":
                            return false;
                        default:
                            if (custom_options?.length > 0 || minQty > 1) return false
                            return el?.qty?.[0] > 0 || !!parseFloat(backOrderValue);
                    }
                }
                const spPriceNumber = specialPriceTimeToggle(el, currency, locale)
                const mainBody = {
                    ...productCurrencyToggle({
                        ...el,
                        flats: [{
                            ...el.flats[0],
                            name: el.flats[0]?.name ?? "",
                            price: handleAmdPrice(currency, el.flats[0].price),
                            special_price: handleAmdPrice(currency, specialPriceTimeToggle(el, currency, locale)),
                            min_price: handleAmdPrice(currency, el.flats[0].min_price),
                        }],
                    }, currency, locale),
                    images: el.images.length > 0
                        ? el.images.map(elem => `/storage/${elem}`)
                        : ["/_next/static/media/defaultpic.119a8e64.webp"]
                }
                if (el.type === "bundle") {
                    const bundle_options = await bundleProductHandle({
                        product: el,
                        models,
                        locale,
                        selectedRate: currency,
                        outStockAllow: allowResponse
                    })
                    const optionQuantity = bundle_options?.bundle_options?.map(({option_product_info}) => {
                        return option_product_info?.find(findItem => !!findItem.is_default) || {}
                    })
                    const totalPrice = optionQuantity?.reduce((total, { optionDefaultQty, price }) => {
                        return total + optionDefaultQty * price;
                    }, 0);
                    return {
                        ...mainBody,
                        flats: [{
                            ...el.flats[0],
                            name: el.flats[0]?.name ?? "",
                            price: formatPrice(totalPrice, currency, locale),
                            min_price: formatPrice(totalPrice, currency, locale),
                            special_price: null
                        }]
                    }
                }
                if (!!el.variants.length) {
                    return {
                        ...handleConfigPrice(mainBody, currency, locale),
                        flats: [{
                            ...el.flats[0],
                            name: el.flats[0]?.name ?? "",
                            price: formatPrice(handleConfigPrice(mainBody, currency, locale).flats[0].price, currency, locale),
                            min_price: formatPrice(handleConfigPrice(mainBody, currency, locale).flats[0].min_price, currency, locale),
                            special_price: el.flats[0].special_price ? formatPrice(handleConfigPrice(mainBody, currency, locale).flats[0].special_price, currency, locale) : null
                        }]
                    }
                }
                return {
                    ...mainBody,
                    isProductInStock: inStockHandle(),
                    flats: [{
                        ...el.flats[0],
                        min_qty: minQty,
                        name: el.flats[0]?.name ?? "",
                        price: formatPrice(mainBody.flats[0].price, currency, locale),
                        min_price: formatPrice(mainBody.flats[0].min_price, currency, locale),
                        special_price: spPriceNumber ? formatPrice(spPriceNumber, currency, locale) : null
                    }]
                }
            })
            .filter(el => el.id !== product_id))
        // return currencyUpdateRes.filter(({ flats: [{ product_id = 0 } = {}] = [] }) => product_id !== productId)
    } catch (err) {
        throw err;
    }
};
/*** NEW UPSELL PRODUCTS ***/

//AFTER ALL IS DONE -> WILL DO
// getUpOrCrossProd
const Get_Up_Sell_Products = async (options, models) => {
    const {locale, limit, product_id, rate, symbol} = options;
    const selectedRate = {
        exchange_rate: {
            rate,
        },
        symbol,
    }
    try {
        const allowResponse = await allowOutOfStock(models);
        const res = await models.product_up_sells.find({parent_id: {$in: product_id.split(",")}});
        if (res.length > 0) {
            const productIds = res.map((e) => e.child_id);
            const query = {
                "flats.locale": locale,
                "flats.status": 1,
                id: {$in: productIds},
                parent_id: null
            }
            if (!Number(allowResponse)) {
                query["$or"] = outOfStockProductMatch
            }
            const products = await
                models
                    .products_v2
                    .find(query)
                    .limit(Number(limit));

            const result = parseClone(products)
            const newProducts = findFlatsExactLocale(result, locale);
            const modifiedRes = imageAddFields(newProducts)
            const finalResultCurr = modifiedRes.map(el => productCurrencyToggle(el, selectedRate, locale))
            return await addMinQuantityController(models, finalResultCurr);
        } else {
            return res;
        }

    } catch (error) {
        throw error;
    }
};
//AFTER ALL IS DONE -> WILL DO
// getUpOrCrossProd
/*** NEW CROSS-SELL PRODUCTS ***/
const Get_Cross_Sell_Products = async (options, models) => {
    const {locale, limit, product_id, rate, symbol} = options;
    const selectedRate = {
        exchange_rate: {
            rate,
        },
        symbol,
    }
    try {
        const allowResponse = await allowOutOfStock(models);
        const res = await models.product_cross_sells.find({parent_id: {$in: product_id.split(",").map(Number)}});
        if (res.length > 0) {
            const productIds = res.map((e) => e.child_id);
            const query = {
                "flats.locale": {$in: [locale, "en"]},
                "flats.status": 1,
                id: {$in: productIds},
                parent_id: null
            }
            if (!Number(allowResponse)) {
                query["$or"] = outOfStockProductMatch
            }
            const result = await
                models
                    .products_v2
                    .find(query)
                    .limit(Number(limit));
            const localeProducts = findFlatsExactLocale(result, locale);
            const modifiedRes = imageAddFields(localeProducts)
            const randomProducts = [];
            const newProducts = [];

            while (randomProducts.length < modifiedRes.length) {
                let r = Math.floor(Math.random() * modifiedRes.length);
                if (randomProducts.indexOf(r) === -1) randomProducts.push(r);
            }

            for (let i = 0; i < modifiedRes.length; i++) {
                newProducts.push(modifiedRes[randomProducts[i]]);
            }
            const updateQuantityRes = await addMinQuantityController(models, newProducts)
            return updateQuantityRes.map(el => productCurrencyToggle(el, selectedRate, locale));
        } else {
            return res;
        }
    } catch (error) {
        throw error;
    }
};
const Get_Product_Options = (options, models) => {
    const {locale} = options;

    return allowOutOfStock(models).then(allowResponse => {
        return new Promise((resolve, reject) => {
            models.product_options.find().exec((err, productOptions) => {
                if (err) {
                    reject(err);
                    return;
                }

                models.product_option_values.find().exec((err, productOptionValues) => {
                    if (err) {
                        reject(err);
                        return;
                    }

                    const options = productOptions.map(option => {
                        const children = productOptionValues
                            .filter(value => value.product_option_id === option.id)
                            .map(value => {
                                let label = value.label;
                                if (value.translations && value.translations.length > 0) {
                                    const translation = value.translations.find(trans => trans.locale === locale);
                                    if (translation) {
                                        label = translation.label;
                                    }
                                }

                                return {
                                    id: value.id,
                                    label: label,
                                    admin_name: value?.admin_name,
                                    price: value.price,
                                    sort_order: value.sort_order
                                };
                            });

                        return {
                            id: option.id,
                            title: option.title,
                            product_id: option.product_id,
                            required: option.required,
                            type: option.type,
                            children: children
                        };
                    });

                    resolve(options);
                });
            });
        });
    });
};

const Get_New_Category_Products = async (
    slug,
    locale,
    limit = 12,
    models,
    page = 1,
    sortBy,
    findAllAttributes,
    isInfinite,
    filterValues,
    selectedRate = {code: "USD"},
    isMobile,
    backOrderValue
) => {
    try {
        const outStockAllow = await allowOutOfStock(models);
        let resolveCategories = {};
        let queryParams = {
            "flats.locale": locale,
            "flats.status": 1,
        }
        if (slug && slug !== "all") {
            resolveCategories = await models.categories.findOne({slug});
            if (!resolveCategories || resolveCategories.length === 0) {
                return {notFound: true};
            }
            queryParams.category_ids = resolveCategories.id
        }
        if (!Number(outStockAllow)) {
            queryParams["$or"] = outOfStockProductMatch;
        }
        const pipeline = [{ $match: queryParams }];
        if (page === -1) { //I set page id -1 for builder component, if the id is not -1 it is for next.js
            pipeline.push({ $limit: limit });
        }
        const allItems = await models.products_v2.aggregate(pipeline);
        const parsedAllItems = parseClone(allItems);
        const objectPropertyHandle = (prId, findItemAttr) => {
            const AttrKeysArr = Object.keys(findItemAttr).slice(1);
            const AttrValuesArr = Object.values(findItemAttr).slice(1);
            const indexPrice = AttrKeysArr.findIndex(indexPriceKey => indexPriceKey === "price")
            if (indexPrice > -1) {
                AttrKeysArr.splice(indexPrice, 1)
                AttrValuesArr.splice(indexPrice, 1)
            }
            return AttrKeysArr.reduce((acc, elemKey, indexKey) => {
                if (
                    findItemAttr.hasOwnProperty(elemKey)
                    && filterValues[elemKey].split(",").find(attrValueI => {
                        if (String(AttrValuesArr[indexKey]).includes(",") && !Array.isArray(AttrValuesArr[indexKey])) {
                            return AttrValuesArr[indexKey].split(",").some(elemString => String(elemString) === String(attrValueI))
                        }
                        if (Array.isArray(AttrValuesArr[indexKey])) {
                            return AttrValuesArr[indexKey].some(elemString => String(elemString) === String(attrValueI))
                        }
                        return String(attrValueI) === String(AttrValuesArr[indexKey])
                    })
                    && acc
                ) {
                    const findIndexIntl = acc?.flats?.findIndex(ii => ii?.locale === locale)
                    acc.flats[findIndexIntl > 0 ? findIndexIntl : 0][elemKey] = findItemAttr[elemKey];
                    return acc;
                }
            }, {...prId})
        }
        const addAttrInFlats = parsedAllItems.map(i => {
            const findItemAttr = findAllAttributes?.find(elem => elem.product_id === i.id)
            if (findItemAttr) {
                objectPropertyHandle(i, findItemAttr)
            }
            return i;
        }).filter(F => F !== undefined);
        const updateQuantityRes = await addMinQuantityController(models, addAttrInFlats);
        const filteredProductFlats = findFlatsExactLocale(updateQuantityRes, locale)
        const updatedCurrResult = await Promise.all(filteredProductFlats.map(async el => {
            const custom_options = await models.product_options.find({product_id: el.id, required: {$in: [1, "1"]}});
            const minQty = el?.flats?.[0]?.min_qty ? el?.flats?.[0]?.min_qty : 0
            const inStockHandle = () => {
                switch (el.type) {
                    case "downloadable":
                    case "bundle":
                    case "configurable":
                        return false;
                    default:
                        if (custom_options?.length > 0 || minQty > 1) return false
                        return el?.qty?.[0] > 0 || !!parseFloat(backOrderValue);
                }
            }
            const spPriceNumber = specialPriceTimeToggle(el, selectedRate, locale)
            const mainBody = {
                ...productCurrencyToggle({
                    ...el,
                    isProductInStock: inStockHandle(),
                    flats: [{
                        ...el.flats[0],
                        min_qty: minQty,
                        name: el.flats[0].name ?? "",
                        price: handleAmdPrice(selectedRate, el.flats[0].price),
                        special_price: spPriceNumber ? specialPriceTimeToggle(el, selectedRate, locale) : null,
                        min_price: handleAmdPrice(selectedRate, el.flats[0].min_price),
                    }],
                }, selectedRate, locale),
                images: el.images.length > 0
                    ? el.images.map(elem => isMobile ? `/storage/medium/${elem}` : `/storage/${elem}`)
                    : ["/_next/static/media/defaultpic.119a8e64.webp"]
            }
            if (el.type === "bundle") {
                const bundle_options = await bundleProductHandle({
                    product: el,
                    models,
                    locale,
                    selectedRate,
                    outStockAllow
                })
                const optionQuantity = bundle_options?.bundle_options?.map(({option_product_info}) => {
                    return option_product_info.find(findItem => !!findItem?.is_default) || {}
                })
                const totalPrice = optionQuantity?.reduce((total, {optionDefaultQty, price}) => {
                    return total + optionDefaultQty * price;
                }, 0);
                return {
                    ...mainBody,
                    flats: [{
                        ...el.flats[0],
                        price: handleAmdPrice(selectedRate, totalPrice),
                        special_price: null,
                        min_price: handleAmdPrice(selectedRate, totalPrice)
                    }]
                }
            }
            if (!!el.variants.length) {
                return handleConfigPrice(mainBody, selectedRate, locale)
            }
            return mainBody
        }))
        const finalCatProductsResult = updatedCurrResult
            .sort((a, b) => b.id - a.id)
            .sort((a, b) =>
                (sortBy && a.flats[0].min_price - b.flats[0].min_price)
                || (sortBy === false && b.flats[0].min_price - a.flats[0].min_price));
        return buildNeededData(finalCatProductsResult);
    } catch (error) {
        console.log(error, "___THIS IS ERROR MESSAGE FROM CATCH!!!")
    }
};

/*** NEW CATEGORY PRODUCT PAGE ***/
const Get_New_Category_Products1 = async (
    slug,
    locale,
    limit = 12,
    models,
    page = 1,
    sortBy,
    isInfiniteScroll,
    filterInfo,
    selectedRate = {code: "USD"},
    isMobile,
    backOrderValue,
    prevProducts = []
) => {
    const outStockAllow = await allowOutOfStock(models);
    const category = slug && slug !== "all"
        ? await models.categories.findOne({ "translations.slug": slug })
        : null;

    const categoryId = category ? category.id : null;
    const showCatalog = category?.display_mode !== "description_only";

    const matchStage = {
        "flats.locale": locale,
        "flats.status": 1,
        "flats.visible_individually": 1
    };
    const sortStage = sortBy
        ? [{ $sort: { "flats.min_price": sortBy } }]
        : [
            {
                $addFields: {
                    sortPosition: {
                        $cond: [
                            {
                                $and: [
                                    { $isArray: "$flats" },
                                    { $gt: [{ $size: "$flats" }, 0] },
                                    {
                                        $and: [
                                            { $ne: [{ $arrayElemAt: ["$flats.product_number", 0] }, null] },
                                            { $ne: [{ $arrayElemAt: ["$flats.product_number", 0] }, ""] },
                                        ],
                                    },
                                ],
                            },
                            { $toDouble: { $arrayElemAt: ["$flats.product_number", 0] } },
                            Number.MAX_SAFE_INTEGER,
                        ],
                    },
                },
            },
            {
                $sort: {
                    sortPosition: 1,
                    id: -1,
                },
            },
        ];

    const baseMatch = {
        "flats.locale": locale,
        "flats.status": 1,
        ...(categoryId && { category_ids: categoryId }),
        "flats.visible_individually": 1
    };
    if (categoryId) {
        matchStage.category_ids = categoryId;
    }

    if (!Number(outStockAllow)) {
        matchStage["$or"] = outOfStockProductMatch;
    }
    const {price, ...filterValues} = filterInfo || {}
    if (price) {
        const [min, max] = price.split(",").map(Number);
        //TODO!!! replaced version at first
        // matchStage["flats.min_price"] = { ...(min ? {$gte: min} : {}), ...(max ? {$lte: max} : {})};
        const priceFilter = {
            $or: [
                // 🟢 Case 1: simple product or price on product itself
                {
                    type: { $ne: "configurable" },
                    "flats.min_price": {
                        ...(min ? { $gte: min / selectedRate?.exchange_rate.rate } : {}),
                        ...(max ? { $lte: max / selectedRate?.exchange_rate.rate } : {}),
                    },
                },

                // 🟢 Case 2: configurable product with variant prices in range
                {
                    type: "configurable",
                    variants: {
                        $elemMatch: {
                            "flats.min_price": {
                                ...(min ? { $gte: min / selectedRate?.exchange_rate.rate } : {}),
                                ...(max ? { $lte: max / selectedRate?.exchange_rate.rate } : {}),
                            },
                        },
                    },
                },
            ],
        };

        Object.assign(matchStage, priceFilter);
    }
    if (filterValues && Object.keys(filterValues).length) {
        const attributes = await models.attributes.aggregate([{ $match: { code: { $in: Object.keys(filterValues) } } }]);
        const attributeType = {
            select: "integer_value",
            text: "text_value",
            boolean: "boolean_value",
            textarea: "text_value",
            date: "date_value",
            date_time: "datetime_value",
            checkbox: "text_value",
            multiselect: "text_value"
        }
        const normalizeFilterValues = (value) => {
            let filterInValArr = []
            if (value.includes(",")) {
                value.split(",").forEach(elem => {
                    if (typeof elem === "string") {
                        if (isNaN(+elem)) {
                            filterInValArr.push(elem)
                        } else {
                            filterInValArr.push(+elem);
                            filterInValArr.push(elem)
                        }
                    } else {
                        filterInValArr.push(elem)
                        filterInValArr.push(String(elem))
                    }
                })
            } else {
                if (typeof value === "string") {
                    if (isNaN(+value)) {
                        filterInValArr.push(value)
                    } else {
                        filterInValArr.push(+value);
                        filterInValArr.push(value)
                    }
                } else {
                    filterInValArr.push(value)
                    filterInValArr.push(String(value))
                }
            }
            return filterInValArr
        }
        const super_attr_filter_array = Object.entries(filterValues).map(([field, value]) => ({
            field,
            value: normalizeFilterValues(value)
        }))
        const product_attr_filter_array = attributes.map(attr => {
            return {
                attribute_id: attr.id,
                field: attributeType[attr.type],
                value: normalizeFilterValues(filterValues[attr.code])
            }
        })
        const productIds = await models.product_attribute_values.aggregate([
            {
                $match: {
                    $or: product_attr_filter_array.map(f => ({
                        attribute_id: f.attribute_id,
                        [f.field]: Array.isArray(f.value) ? { $in: f.value } : f.value
                    }))
                }
            },
            {
                $group: {
                    _id: "$product_id",
                    matchedAttributes: { $addToSet: "$attribute_id" }
                }
            },
            {
                $match: {
                    matchedAttributes: { $size: product_attr_filter_array.length }
                }
            },
            {
                $project: { _id: 1 }
            },
            {
                $unionWith: {
                    coll: "product_super_attributes",
                    pipeline: [
                        {
                            $match: {
                                $or: super_attr_filter_array.map(f => ({
                                    [f.field]: { $in: f.value },
                                })),
                            },
                        },
                        {
                            $project: { _id: 0, _id_as_product_id: "$product_id" },
                        },
                        {
                            $project: { _id: "$_id_as_product_id" },
                        },
                    ],
                },
            },

            {
                $group: {
                    _id: null,
                    product_ids: { $addToSet: "$_id" }
                }
            },
            {
                $project: { _id: 0, product_ids: 1 }
            }
        ]);
        const [ { product_ids = [] } = {} ] = productIds || [];
        matchStage.id = { $in: product_ids }
    }

    const skip = (page - 1) * limit;
    const [{ data = [], total = 0, priceStats } = {}] = await models.products_v2.aggregate([
            {
                $facet: {
                    data: [
                        { $match: matchStage },
                        ...sortStage,
                        { $skip: skip },
                        { $limit: limit },
                    ],
                    totalCount: [
                        { $match: matchStage },
                        { $count: "count" }
                    ],
                    priceStats: [
                        { $match: baseMatch },
                        { $unwind: "$flats" },
                        { $match: { "flats.locale": locale } },
                        {
                            $group: {
                                _id: null,
                                min_price: { $min: "$flats.min_price" },
                                max_price: { $max: "$flats.min_price" }
                            }
                        }
                    ]

                },
            },
            {
                $project: {
                    data: 1,
                    total: { $arrayElemAt: ["$totalCount.count", 0] },
                    priceStats: { $arrayElemAt: ["$priceStats", 0] },
                },
            },
        ]
    )
    const parsedAllItems = parseClone(data);
    const updateQuantityRes = await addMinQuantityController(models, parsedAllItems);
    const filteredProductFlats = findFlatsExactLocale(updateQuantityRes, locale)
    const updatedCurrResult = await Promise.all(filteredProductFlats.map(async el => {
        const custom_options = await models.product_options.find({product_id: el.id, required: {$in: [1, "1"]}});
        const minQty = el?.flats?.[0]?.min_qty ? el?.flats?.[0]?.min_qty : 0
        const inStockHandle = () => {
            switch (el.type) {
                case "downloadable":
                case "bundle":
                case "configurable":
                    return false;
                default:
                    if (custom_options?.length > 0 || minQty > 1) return false
                    return el?.qty?.[0] > 0 || !!parseFloat(backOrderValue);
            }
        }
        const mainBody = {
            ...productCurrencyToggle({
                ...el,
                isProductInStock: inStockHandle(),
                flats: [{
                    ...el.flats[0],
                    min_qty: minQty,
                    name: el.flats[0].name ?? "",
                    price: handleAmdPrice(selectedRate, el.flats[0].price),
                    special_price: specialPriceTimeToggle(el, selectedRate, locale),
                    min_price: handleAmdPrice(selectedRate, el.flats[0].min_price),
                }],
            }, selectedRate, locale),
            images: el.images.length > 0
                ? el.images.map(elem => isMobile ? `/storage/medium/${elem}` : `/storage/${elem}`)
                : ["/_next/static/media/defaultpic.119a8e64.webp"]
        }
        if (el.type === "bundle") {
            const bundle_options = await bundleProductHandle({
                product: el,
                models,
                locale,
                selectedRate,
                outStockAllow
            })
            const optionQuantity = bundle_options?.bundle_options?.map(({option_product_info}) => {
                return option_product_info.find(findItem => !!findItem?.is_default) || {}
            })
            const totalPrice = optionQuantity?.reduce((total, {optionDefaultQty, price}) => {
                return total + optionDefaultQty * Number(price);
            }, 0);
            return {
                ...mainBody,
                flats: [{
                    ...el.flats[0],
                    price: formatPrice(totalPrice, selectedRate, locale),
                    special_price: null,
                    min_price: formatPrice(totalPrice, selectedRate, locale)
                }]
            }
        }
        if (!!el.variants.length) {
            const configInfo = handleConfigPrice(mainBody, selectedRate, locale)
            return {
                ...configInfo,
                flats: [{
                    ...configInfo.flats[0],
                    price: formatPrice(configInfo.flats[0].price, selectedRate, locale),
                    min_price: formatPrice(configInfo.flats[0].min_price, selectedRate, locale),
                    special_price: configInfo.flats[0].special_price ? formatPrice(configInfo.flats[0].special_price, selectedRate, locale) : null
                }]
            }
        }
        return {
            ...mainBody,
            flats: [{
                ...mainBody.flats[0],
                price: formatPrice(mainBody.flats[0].price, selectedRate, locale),
                special_price: mainBody.flats[0].special_price ? formatPrice(mainBody.flats[0].special_price, selectedRate, locale) : null,
                min_price: formatPrice(mainBody.flats[0].min_price, selectedRate, locale),
            }]
        }
    }))
    const pageCount = Math.ceil(total / 12)
    const getPages = () => {
        const total = pageCount;
        const current = +page;
        const visibleRange = 2; // how many pages to show before/after current
        // Ensure the start doesn't go below 1
        const start = Math.max(1, current - visibleRange);
        // Ensure the end doesn't exceed total pages
        const end = Math.min(total, start + visibleRange * 2);

        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };
    const finalProducts = isInfiniteScroll
        ? [...(prevProducts || []), ...updatedCurrResult]
        : updatedCurrResult;

    return {
        data: finalProducts,
        max_price: priceStats?.max_price * selectedRate?.exchange_rate.rate || 0,
        dispatches: {
            setInitialMinPrice: priceStats?.min_price * selectedRate?.exchange_rate.rate || 0,
            setInitialMaxPrice: priceStats?.max_price * selectedRate?.exchange_rate.rate || 0,
        },
        total,
        isInfiniteScroll,
        pageCount: Math.ceil(total / 12),
        getPages: getPages(),
        showCatalog: showCatalog
    };
};

const Get_Products_By_Category = async (id, locale, limit = 12, models, selectedRate = {code: "USD"}, isMobile) => {
    try {
        let queryParams = {
            "flats.locale": locale,
            "flats.status": 1,
            ...(id && id !== "all" && id !== "0" ? {category_ids: Number(id)} : {})
        }
        const allItems = await models.products_v2.find(queryParams).limit(+limit)

        const parsedAllItems = parseClone(allItems);
        const updateQuantityRes = await addMinQuantityController(models, parsedAllItems)
        const filteredProductFlats = findFlatsExactLocale(updateQuantityRes, locale)
        const updatedCurrResult = filteredProductFlats.map(el => {
            const mainBody = {
                ...productCurrencyToggle({
                    ...el,
                    flats: [{
                        ...el.flats[0],
                        name: el.flats[0].name ?? "",
                        price: handleAmdPrice(selectedRate, el.flats[0].price),
                        special_price: specialPriceTimeToggle(el, selectedRate, locale),
                        min_price: handleAmdPrice(selectedRate, el.flats[0].min_price),
                    }],
                }, selectedRate, locale),
                images: el.images.length > 0
                    ? el.images.map(elem => isMobile ? `/storage/medium/${elem}` : `/storage/${elem}`)
                    : ["/_next/static/media/defaultpic.119a8e64.webp"]
            }
            if (!!el.variants.length) {
                return handleConfigPrice(mainBody, selectedRate, locale)
            }
            return mainBody
        })

        return buildNeededData(updatedCurrResult);
    } catch (error) {
        console.log(error, "___THIS IS ERROR MESSAGE FROM CATCH!!!")
    }
};

const Get_Scroll_Products = async (models, type, locale, limit) => {
    try {
        const allProducts = await getNewFeatured(models, type, locale, limit)
        return imageAddFields(allProducts)
    } catch (err) {
        throw err
    }
}

/*********************** CUSTOMER GROUP PRICE ***********************/

const Get_Customer_Groups = async (models) => {
    try {
        const res = await models.product_customer_group_prices.find({});
        return parseClone(res);
    } catch (err) {
        console.log(err, "Error in -> !__! Get_Customer_Groups !__!")
    }
}

const Get_Size_Chart = async (id, models) => {
    try {
        const res = await models.size_chart.findOne({id});
        return parseClone(res);
    } catch (err) {
        console.log(err, "Error in -> !__! Get_Size_Chart !__!")
    }
}

const Get_Product_By_Url_Key = async (url_key, locale, models) => {
    try {
        const res = await models.products_v2.findOne({"flats.url_key": url_key});
        console.log(res, "res")
        return parseClone(res);
    } catch (err) {
        console.log(err, "Error in -> !__! Get_Product_By_Sku !__!")
    }
}

module.exports = {
    Get_New_And_Featured_Products,
    Get_Product_For_Product_Inner_Page,
    Get_Related_Products,
    Get_Cross_Sell_Products,
    Get_Up_Sell_Products,
    Get_New_Category_Products,
    Get_New_Category_Products1,
    Get_Products_By_Category,
    Get_Searched_Products,
    Get_Product_Options,
    Get_Scroll_Products,
    Get_Customer_Groups,
    Get_Size_Chart,
    Get_Product_By_Url_Key
}
